export const AdminStatusCssClasses = ["danger", "success", "info", ""];
export const AdminStatusTitles = ["Suspended", "Active", "Pending", ""];
export const AdminTypeCssClasses = ["success", "primary", ""];
export const AdminTypeTitles = ["N/A", "Support", "Admin", "Super Admin"];
export const defaultSorted = [{ dataField: "id", order: "asc" }];
export const sizePerPageList = [
  { text: "3", value: 3 },
  { text: "5", value: 5 },
  { text: "10", value: 10 }
];
export const initialFilter = {
  filter: {
    lname: "",
    fname: "",
    email: "",
    ipAddress: ""
  },
  sortOrder: "asc", // asc||desc
  sortField: "id",
  pageNumber: 1,
  pageSize: 10
};
